var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"facebook"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",{"id":"facebook"},React.createElement("path",{"d":"M48.5,0h-38A10.51,10.51,0,0,0,0,10.5v38A10.51,10.51,0,0,0,10.5,59H30.1V37.17H23.6V29.64h6.5V24.09c0-6.45,3.94-10,9.69-10a53.54,53.54,0,0,1,5.81.3v6.73h-4c-3.13,0-3.73,1.48-3.73,3.66v4.81h7.45l-1,7.53H37.88V59H48.5A10.51,10.51,0,0,0,59,48.5v-38A10.51,10.51,0,0,0,48.5,0Z"}))))]);
}

Facebook.defaultProps = {"viewBox":"0 0 59 59"};

module.exports = Facebook;

Facebook.default = Facebook;
